module.exports = __webpack_public_path__ + "static/media/card.7b02ad36.webp";